module.exports = __webpack_public_path__ + "static/img/cpfw-ptzs3.445913e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-ptzs3.png
// module id = prZ2
// module chunks = 0